export const WEBRTC_DROPPED_FRAMES_MAX_RETRY_ATTEMPTS: number = 5;

export const WEBRTC_MAX_CONSECUTIVE_MISSED_VIDEO_REPORTS_BEFORE_ERROR = 5;
